// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tooltip_wrapper__1WVYA","label":"Tooltip_label__1wFQE","item":"Tooltip_item__R8rij","itemValue":"Tooltip_itemValue__3JTU4"};